var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSecondary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1104 2048",
    width: 1280,
    height: 1280,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(36)",
    d: "m0 0h19l1 2 8 3h106l910 1 1 1v1326l-271 1-2-1-1-12-2-81v-974l-421 2-62 1h-29v190l-2 873-4 2h-268l-2-1-1-7v-38l-2-215-1-641v-55l2-168 1-110v-59h-6l-2-1 1-3 6-2 5-4h2l2-5 2-4h-11l-7-1 2-4 17-8 16-1-1-2-6-3zm13 4 1 3 1-3z",
    fill: "#5A5A5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(104,1595)",
    d: "m0 0h35l10 5 8 8 11 16 10 14 16 21 20 26 11 14 3 3 1-22 2-72 1-12 1-1h42l2 111 1 73-2 2-12 1h-27l-14-14-10-13-11-14-14-18-26-36-8-10-6-5-1 108-3 2h-38l-3-1-1-2-1-20 2-144v-18z",
    fill: "#5A5A5A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(315,1595)",
    d: "m0 0h146l1 1v34l-2 1h-98v41h90l2 1v33l-6 1h-86l1 7 1 20 1 9 27 1 48 1 22 1 2 1 2 15 1 17-1 2-4 1h-144l-3-1-1-2-1-11v-171z",
    fill: "#5A5A5A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(901,1595)",
    d: "m0 0h37l6 5 8 16 18 44 17 41 18 43 10 25 2 7v5l-3 1h-38l-8-2-4-6-7-20-3-3-45-1-37-1-8 27-4 5-2 1h-40l-4-2-1-6 9-21 20-45 17-40 13-31 16-34 7-6zm12 50-6 12-8 19-11 28-2 8 1 1h54l-2-11-9-26-8-20-7-11z",
    fill: "#5A5A5A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(552,1592)",
    d: "m0 0h18l22 3 23 5 16 8 2 2v9l-3 16-6 12-3 1-25-8-23-6-22-1-5 2-3 6v9l7 6 20 8 27 11 16 8 11 6 5 5 9 15v34l-6 11-9 11h-2v2h-2v2l-8 6-19 6-5 1h-46l-30-8-12-6-14-9-3-5v-7l3-9 8-14 2-3 5 1 21 9 17 7 18 4h14l11-2 5-5 3-8-3-7-4-3-50-18-16-7-12-9-10-12-4-9v-21l8-17 6-9 8-7 14-9 20-6z",
    fill: "#5A5A5A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(386 1e3)",
    d: "m0 0h18l35 3 4 1 1 36 2 6 12 13 9 10 19 19 7 3 20 4 19 3 2 4 2 28 2 8 7 11 9 10 20 20 5 4 6 2 36 5 2 2 3 31 4 10 7 11 14 14v2h2l4 4v2l4 2 8 7 8 2 31 2 2 2 1 8 1 19v20l-2 2-5 1h-42l-1-1-1-24-4-13-6-9-14-15-8-8-7-8-5-4-15-5-6-1-20-1-4-2-5-35-5-10-11-14-12-13-10-9-11-8-5-2-35-2-1-2v-26l-5-13-6-10-11-13-9-11-10-9-5-3-14-2-30-2-1-1-1-12v-42z",
    fill: "#5A5A5A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(651,1595)",
    d: "m0 0h158l1 1v33l-1 2-28 2h-27v147l-7 2h-39l-2-1-1-23v-119l-1-8h-52l-1-2-2-25v-8z",
    fill: "#5A5A5A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(388,1098)",
    d: "m0 0h49l4 2 1 3 2 30 2 6 12 18 11 12 9 9 2 1v2l12 6 5 1 25 2 8 2 1 7v37l-2 7-7 4-36-2-7-2-2-7-3-33-1-7-7-2-13-14-9-11-10-11-11-4-9-2-24-2-4-2-1-6v-38l2-5z",
    fill: "#5A5A5A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(584,1097)",
    d: "m0 0h34l3 2 3 36 9 15 12 12 8 7 16 17 7 2 31 2 2 3 3 12v17l-1 20-1 1h-45l-4-10-3-13-2-15-5-10-10-13-10-11-5-5-15-12-5-2-34-2-2-1-1-4v-44l1-2 3-1z",
    fill: "#5A5A5A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(418,1951)",
    d: "m0 0 11 1 9 1 5 5 12 14 7 8 10 10 2 1-1-2v-37l1-1h18l1 1v72l-15 1-5-2-12-12-10-13-6-7-8-5 2 36-1 2-15 1-4-1-1-7z",
    fill: "#5F5F5F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(12,1951)",
    d: "m0 0h50l10 4 9 7 6 9 1 3v25l-4 10-6 8-9 7-4 2-7 1h-39l-7-1-3-4v-66l1-4zm20 13-3 4v38l3 5 3 1h19l8-4 6-7 2-10v-7l-3-9-5-7-17-4z",
    fill: "#5B5B5B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(816,1951)",
    d: "m0 0h10l6 3 12 14 8 10 7 10 7 4v-28l1-12 1-1h16v73l-2 2h-11l-10-7-9-10-11-14-4-6-3-1-1 36h-19l-1-1v-70z",
    fill: "#5B5B5B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(114,1951)",
    d: "m0 0h55l1 1v13l-1 1h-35l3 12 2 1 28 2-1 12-3 1h-18l-13-1 2 19h35l2 1 1 13-7 1h-47l-5-2-1-1-1-10v-21l1-30 1-11z",
    fill: "#5B5B5B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(729,1951)",
    d: "m0 0h58v8l-1 6-7 1h-30v15h33l-2 12-5 2-25 1-1 14 38 2 1 1 1 12-1 1-23 1h-33l-3-1-1-3v-62z",
    fill: "#5B5B5B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(994,1951)",
    d: "m0 0h57l1 2v10l-18 2-19 1v15l16-1h16v13l-1 1-33 2 4 13 34 3 4 2v12l-23 1h-36l-2-7z",
    fill: "#5E5E5E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(350,1949)",
    d: "m0 0h21l11 2 7 5 4 8v6l-4 1-15-4h-23l-7 3-2 12v12l2 7 4 5 8 4 10 1 5-3 3-1 2-4 4-7 4-10 5-2 6 2v23l-4 11-5 5-11 2h-29l-6-3-10-8-6-10-3-10v-14l3-8 9-14 9-8z",
    fill: "#5A5A5A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(921,1951)",
    d: "m0 0h41l3 2 1 3v10l-37-2 1 9 4 4 26 9 7 5 2 6v18l-3 5-8 6-9 1h-26l-9-2-4-4-2-9v-4l8 1 10 2h18l6-4-1-6-6-3-22-6-10-7-1-2v-16l4-8 5-7z",
    fill: "#5A5A5A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(206,1951)",
    d: "m0 0h41l3 8 1 7-37-2 3 12 28 12 8 5 1 2v20l-9 10-6 2h-35l-3-1-7-8-1-10 15 1 16 2h6l5-5 1-5-7-3-18-5-17-9v-11l2-11 6-8z",
    fill: "#5A5A5A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(656,1951)",
    d: "m0 0h42l2 1-1 13-3 1-34-2 3 12 11 4 15 5 9 6 4 4 1 9-2 10-4 6-6 5-6 2h-28l-9-1-5-3-1-3v-9l1-1 23 1h16l2-5 2-6-19-4-12-4-11-7-2-2v-14l3-9 6-8z",
    fill: "#5A5A5A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(660,1098)",
    d: "m0 0h50l1 2 2 38v9l-7 2h-44l-3-1v-49z",
    fill: "#5D5D5D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(388,1190)",
    d: "m0 0h35l14 4 2 5v31l-1 10-3 3h-26l-19-1-2-1-2-16v-23z",
    fill: "#5A5A5A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(393,1290)",
    d: "m0 0h39l2 3v35l-29 1-10-1-2-12z",
    fill: "#5A5A5A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(281,1951)",
    d: "m0 0h16l1 1v72l-7 2h-12l-1-1v-20l2-52z",
    fill: "#5A5A5A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(489,1011)",
    d: "m0 0h35l2 2v35l-1 1h-10l-25-2-2-1v-34z",
    fill: "#5D5D5D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(583,1290)",
    d: "m0 0h24l5 2 1 3v34l-4 2-28-2-2-3-2-21v-8l4-6z",
    fill: "#5F5F5F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(685,1011)",
    d: "m0 0h19l1 1v35l-17 2-16-1-2-1-1-5v-27l1-2z",
    fill: "#5E5E5E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(501,1300)",
    d: "m0 0 9 1 2 3v10l-6 3-7-1-3-5 1-9z",
    fill: "#666"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(594,1022)",
    d: "m0 0 11 1 2 1v9l-2 5-5 1-7-3-1-2v-9z",
    fill: "#5E5E5E"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(36)",
    d: "m0 0h19l1 2 8 3 6 1v1h-19v-3h-2l1 3h-6l-5-3-3-2z",
    fill: "#FEFEFE"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(18,12)",
    d: "m0 0h1v9l-11-1 2-4z",
    fill: "#FEFEFE"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(16,33)",
    d: "m0 0 1 3-1 3-6 1-2-1 1-3 6-2z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSecondary);
export default __webpack_public_path__ + "static/media/logo_secondary.3f9bd7a1ec82fa9b638b7e2b2cf5d807.svg";
export { ForwardRef as ReactComponent };